import auth from './requests/auth';
import rest from './requests/rest';

export default {
  auth,
  ...rest
};
